<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 9.49994L11.2 15.4999L8 12.4999"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 9.49994L11.2 15.4999L8 12.4999"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.7998 12.4999C1.7998 15.2051 2.87444 17.7995 4.78732 19.7124C6.70019 21.6253 9.2946 22.6999 11.9998 22.6999C14.705 22.6999 17.2994 21.6253 19.2123 19.7124C21.1252 17.7995 22.1998 15.2051 22.1998 12.4999C22.1998 9.79472 21.1252 7.20031 19.2123 5.28744C17.2994 3.37457 14.705 2.29993 11.9998 2.29993C9.2946 2.29993 6.70019 3.37457 4.78732 5.28744C2.87444 7.20031 1.7998 9.79472 1.7998 12.4999V12.4999Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
